unit Search.ShiptechDepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls;

type
  TfrmSearchShiptechDepot = class(TWebForm)
    WebPanel1: TWebPanel;
    WebPanel2: TWebPanel;
    WebPanel3: TWebPanel;
    WebButton1: TWebButton;
    WebButton2: TWebButton;
    weSearch: TWebEdit;
    dgSearch: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    wdsSearch: TXDataWebDataSet;
    dsSearch: TWebDataSource;
    wdsSearchid: TIntegerField;
    wdsSearchdepotname: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iShiptechDepotID : Integer;
    sShiptechDepotName : String;
  end;

var
  frmSearchShiptechDepot: TfrmSearchShiptechDepot;

implementation

{$R *.dfm}
uses
  stfmssystem.connection;

procedure TfrmSearchShiptechDepot.dgSearchCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iShiptechDepotID := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sShiptechDepotName := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchShiptechDepot.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearchShiptechDepot.WebButton2Click(Sender: TObject);
begin
  sShiptechDepotName := '';
  iShiptechDepotID := -1;
  close;
end;

procedure TfrmSearchShiptechDepot.WebFormShow(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;

begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_ShiptechDepots_View',[],@OnSuccess);
end;

procedure TfrmSearchShiptechDepot.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : wdsSearch.Locate('id', weSearch.Text, [loPartialKey]);
        1 : wdsSearch.Locate('depotname', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.